interface LocalStorageLike {
  setItem(key: string, value: string): void
  getItem(key: string): string | null
  removeItem(key: string): void
}

export const LocalStorage = {
  setItem(key: LocalStorageKey, value: string) {
    this.$window.localStorage.setItem(key, value)
  },
  getItem(key: LocalStorageKey): string | null {
    return this.$window.localStorage.getItem(key)
  },
  removeItem(key: LocalStorageKey): void {
    this.$window.localStorage.removeItem(key)
  },

  get $window(): { localStorage: LocalStorageLike } {
    if (typeof window === 'object') {
      return window
    }

    // Mock window for the context of `localStorage`. This is a getter, so the
    // store has always been rebuilt per access — it never persisted anything.
    const state: Record<string, string> = {}
    return {
      localStorage: {
        setItem(key, value) {
          state[key] = value
        },
        getItem(key) {
          return key in state ? state[key] : null
        },
        removeItem(key) {
          delete state[key]
        }
      }
    }
  }
}

export type LocalStorageKey =
  | 'addBackers'
  | 'confirmation'
  | 'fundName'
  | 'activeTab'
  | 'fundMessage'
  | 'hasRequiredContribution'
  | 'contributionYears'
  | 'hasPro'
